import VerticalLine from './VerticalLine';

export default VerticalLine;
